import { miniApp, openTelegramLink } from '@tma.js/sdk'

/**
 * Check if the app is running inside Telegram WebApp
 * @returns true if running in Telegram WebApp, false otherwise
 */
export function isTelegramWebApp(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const win = window as Window & typeof globalThis & { Telegram?: { WebApp?: unknown } }
  return !!win.Telegram?.WebApp
}

/**
 * Start the bot assistant in chat and close the Mini App so the user can see it.
 *
 * `openTelegramLink` sends `/start assistant` but does not close a compact Mini App
 * opened from a chat button, so the overlay stays on top of the conversation.
 */
export function openAssistantChat(): void {
  const username = import.meta.env.VITE_TELEGRAM_BOT_USERNAME as string
  openTelegramLink(`https://t.me/${username}?start=assistant`)
  if (miniApp.close.isAvailable()) {
    miniApp.close(true)
  }
}

/**
 * Check if we should show fallback UI (for browser testing)
 * @returns true if fallback UI should be shown
 */
export function shouldShowFallbackUI(): boolean {
  return !isTelegramWebApp()
}
